import { addDaysToDate } from 'core/utils';

export type IWeekInvestment = {
    weekNumber: number;
    isCurrentWeek: boolean;
    from: Date;
    to: Date;
    plan: {
        investment: number;
        sum: number;
    };
    fact: {
        investment: number;
        sum: number;
    };
};

type IGetWeekInvestmentsArg = {
    investments: {
        weekNumber: number;
        sum: number;
    }[];
    startSum: number;
    startDate: string;
};

export const getWeekInvestments = (data: IGetWeekInvestmentsArg) => {
    const { investments, startSum } = data;
    const startDate = new Date(data.startDate);

    return new Array(52).fill(null).reduce<IWeekInvestment[]>((acc, _, index) => {
        const prev = acc[acc.length - 1];
        const from = addDaysToDate(startDate, index * 7);
        from.setHours(0, 0, 0, 0);
        const to = addDaysToDate(startDate, index * 7 + 6);
        to.setHours(23, 59, 59, 0);
        const planInvestment = startSum + startSum * index;

        // Пытаемся найти инвестиции пользователя в эту неделю, если нашли возвращаем сумму.
        // Если не нашли, но неделя уже началась или прошла - возвращаем 0.
        // Во всех остальных случаях возвращаем null.
        const factInvestment = investments.find(i => i.weekNumber === index + 1)?.sum || (from < new Date() ? 0 : null);

        acc.push({
            weekNumber: index + 1,
            isCurrentWeek: from <= new Date() && to > new Date(),
            from,
            to,
            plan: {
                investment: planInvestment,
                sum: prev ? prev.plan.sum + planInvestment : planInvestment,
            },
            fact: {
                investment: factInvestment,
                sum: factInvestment !== null ? (prev ? factInvestment + prev.fact.sum : factInvestment) : null,
            },
        });

        return acc;
    }, []);
};

export const sliceWeekInvestments = (weekInvestments: IWeekInvestment[], count: number) => {
    const currentWeekIndex = weekInvestments.findIndex(_ => _.isCurrentWeek);

    // Текущая неделя не началась/закончилась/равна первой неделе
    if (currentWeekIndex <= 0) {
        return weekInvestments.slice(0, count);
    }

    return weekInvestments.slice(currentWeekIndex - 1, currentWeekIndex - 1 + count);
};
